import React, { useState, useEffect } from "react";
import axios from "axios";
import Moment from 'react-moment';
import ReactLoading from 'react-loading';
import Modal from 'react-bootstrap/Modal';
import { Container, Row, Col, Form, Button, ProgressBar, ModalFooter } from "react-bootstrap"
import TablePagination from '@mui/material/TablePagination';
import exportValue from "../../apiconfig";
import Left_panel from '../Left_panel'
import Sub_header from '../Sub_header'
import '../../components/loader.css';
import Swal from 'sweetalert2'
import { useNavigate, useParams } from 'react-router-dom'
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

const PrePayoutSummary = () => {
    const [isSidebarOpen, setIsSidebarOpen] = React.useState(false);

    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
        const homeSection = document.querySelector('.home-section');
        if (homeSection) {
            homeSection.classList.toggle('sidebar-closed');
        }
    };
  return (
    <div>
    <Left_panel isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
      
      <section class="home-section">
              {/* <?php
              include('sub_header.php');
              ?> 
           */}
      <Sub_header/> 

<section class="mt-3">
    <div style={{
      maxWidth: '1200px',
      margin: '0 auto',
      padding: '16px',
      fontFamily: 'Arial, sans-serif'
    }}>
      <h2 style={{ marginBottom: '16px' }}>Pre Payout Summary</h2>
      
      <div style={{
        padding: '16px',
        backgroundColor: '#fff3cd',
        border: '1px solid #ffecb5',
        borderRadius: '4px',
        marginBottom: '24px',
        color: '#664d03'
      }}>
        This is a pre-payout summary designed to give you an estimate of the total amount that will be generated. Please note that this reflects the <span style={{ fontWeight: 'bold', backgroundColor: '#f8f9fa', padding: '2px 4px', borderRadius: '4px' }}>current data only</span> and serves as a reference to help you understand the expected COD payout amount when you proceed to create the payout.
      </div>

      <div style={{
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        gap: '16px',
        marginBottom: '24px'
      }}>
        <div style={{
          flex: '1',
          minWidth: '250px'
        }}>
          <div style={{
            backgroundColor: '#ffc107',
            padding: '16px',
            borderRadius: '8px',
            color: '#000'
          }}>
            <h2 style={{ margin: '0' }}>₹20000.00</h2>
            <small>Total Gross COD Payout</small>
          </div>
        </div>
        
        <div style={{
          flex: '1',
          minWidth: '250px'
        }}>
          <div style={{
            backgroundColor: '#dc3545',
            padding: '16px',
            borderRadius: '8px',
            color: '#fff'
          }}>
            <h2 style={{ margin: '0' }}>- ₹2000.00</h2>
            <small>Total Wallet Adjustments</small>
          </div>
        </div>
        
        <div style={{
          flex: '1',
          minWidth: '250px'
        }}>
          <div style={{
            backgroundColor: '#198754',
            padding: '16px',
            borderRadius: '8px',
            color: '#fff'
          }}>
            <h2 style={{ margin: '0' }}>₹18000.00</h2>
            <small>Total Net COD Payout</small>
          </div>
        </div>
      </div>

      {[1, 2].map((item, index) => (
        <div key={index} style={{
          marginBottom: '24px',
          border: '1px solid #dee2e6',
          borderRadius: '8px'
        }}>
          <div style={{
            padding: '16px',
            backgroundColor: '#f8f9fa',
            borderBottom: '1px solid #dee2e6',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}>
            <h4 style={{ margin: '0' }}>Johnsan & Company</h4>
            <h4 style={{ margin: '0' }}>₹10000.00</h4>
          </div>
          
          <div style={{ padding: '16px' }}>
            <div style={{ overflowX: 'auto' }}>
              <table style={{
                width: '100%',
                borderCollapse: 'collapse',
                border: '1px solid #dee2e6'
              }}>
                <thead>
                  <tr style={{ backgroundColor: '#f8f9fa' }}>
                    <th style={{ padding: '12px', border: '1px solid #dee2e6', textAlign: 'left' }}>AWB Number</th>
                    <th style={{ padding: '12px', border: '1px solid #dee2e6', textAlign: 'left' }}>Carrier</th>
                    <th style={{ padding: '12px', border: '1px solid #dee2e6', textAlign: 'left' }}>Current Status</th>
                    <th style={{ padding: '12px', border: '1px solid #dee2e6', textAlign: 'left' }}>COD Amount</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td style={{ padding: '12px', border: '1px solid #dee2e6' }}>1234567890</td>
                    <td style={{ padding: '12px', border: '1px solid #dee2e6' }}>Delhivery</td>
                    <td style={{ padding: '12px', border: '1px solid #dee2e6' }}>
                      <span style={{
                        backgroundColor: '#198754',
                        color: '#fff',
                        padding: '4px 8px',
                        borderRadius: '4px',
                        fontSize: '0.875em'
                      }}>Delivered</span>
                    </td>
                    <td style={{ padding: '12px', border: '1px solid #dee2e6' }}>₹4000.00</td>
                  </tr>
                  <tr>
                    <td style={{ padding: '12px', border: '1px solid #dee2e6' }}>1234567890</td>
                    <td style={{ padding: '12px', border: '1px solid #dee2e6' }}>Delhivery</td>
                    <td style={{ padding: '12px', border: '1px solid #dee2e6' }}>
                      <span style={{
                        backgroundColor: '#198754',
                        color: '#fff',
                        padding: '4px 8px',
                        borderRadius: '4px',
                        fontSize: '0.875em'
                      }}>Delivered</span>
                    </td>
                    <td style={{ padding: '12px', border: '1px solid #dee2e6' }}>₹4000.00</td>
                  </tr>
                  <tr>
                    <td style={{ padding: '12px', border: '1px solid #dee2e6' }}>1234567890</td>
                    <td style={{ padding: '12px', border: '1px solid #dee2e6' }}>Delhivery</td>
                    <td style={{ padding: '12px', border: '1px solid #dee2e6' }}>
                      <span style={{
                        backgroundColor: '#198754',
                        color: '#fff',
                        padding: '4px 8px',
                        borderRadius: '4px',
                        fontSize: '0.875em'
                      }}>Delivered</span>
                    </td>
                    <td style={{ padding: '12px', border: '1px solid #dee2e6' }}>₹1000.00</td>
                  </tr>
                  <tr style={{ fontWeight: 'bold', backgroundColor: '#0d6efd', color: '#fff' }}>
                    <td colSpan="3" style={{ padding: '12px', border: '1px solid #dee2e6', textAlign: 'right' }}>Total Gross COD Payout</td>
                    <td style={{ padding: '12px', border: '1px solid #dee2e6' }}>₹9000.00</td>
                  </tr>
                  <tr>
                    <td colSpan="3" style={{ padding: '12px', border: '1px solid #dee2e6', textAlign: 'right', color: '#dc3545' }}>Wallet Adjustments</td>
                    <td style={{ padding: '12px', border: '1px solid #dee2e6', color: '#dc3545' }}>- ₹1000.00</td>
                  </tr>
                  <tr style={{ fontWeight: 'bold', backgroundColor: '#f8f9fa' }}>
                    <td colSpan="3" style={{ padding: '12px', border: '1px solid #dee2e6', textAlign: 'right', color: '#198754' }}>Total Net COD Payout</td>
                    <td style={{ padding: '12px', border: '1px solid #dee2e6', color: '#198754', backgroundColor: '#f8f9fa' }}>₹10000.00</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      ))}
    </div>
    </section>
    </section>
    </div>
  );
};

export default PrePayoutSummary;